import { c as _c } from "react/compiler-runtime";
import { Form, Formik } from 'formik';
import { Request } from '../../../../../../../../typings/Request.interface';
import { APISource } from '../../../../../../../../typings/Source.interface';
import Badge from '../../../../common/base/Badge';
import Button from '../../../../common/base/Button';
import { StyledCard, StyledCardSection } from '../../../../common/base/Card';
import Text from '../../../../common/base/Text';
import CopyableField from '../../../../common/CopyableField';
import { StyledRadioCard } from '../../../../common/Form/Fields/RadioCardsInput';
import { Div } from '../../../../common/helpers/StyledUtils';
import { useToasts } from '../../../../common/Toast';
import { RequestListResult } from '../../../../hooks/useRequestList';
import { useState } from 'react';
import { useTheme } from 'styled-components';
import Tabs from '../../../../common/base/Tabs';
import Editor from '../../../../common/Editor';
const TriggerRequest: React.FC<{
  context: {
    source: APISource | null;
    requests_list: RequestListResult;
  };
  mutateContext: (context: {
    source?: APISource;
    request?: Request;
  }) => void;
  nextStep: () => void;
  is_current_step: boolean;
}> = t0 => {
  const $ = _c(18);
  const {
    context: t1,
    nextStep
  } = t0;
  const {
    source
  } = t1;
  const {
    addToast
  } = useToasts();
  const theme = useTheme();
  const [trigger_option, setTriggerOption] = useState("url");
  const [request_format, setRequestFormat] = useState("web_ui");
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = JSON.stringify({
      hello: "world"
    }, null, 2);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [mock_body, setMockBody] = useState(t2);
  const source_url = source?.url;
  const curl_command = `curl -X POST ${source_url ?? ""} \\
  -H "Content-Type: application/json" \\
  -d '{"hello": "world"}'`;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {};
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== addToast || $[3] !== mock_body || $[4] !== nextStep || $[5] !== source_url) {
    t4 = () => {
      if (!source_url) {
        return;
      }
      return fetch(source_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: mock_body
      }).then(() => {
        nextStep();
        addToast("success", "Request sent successfully");
      });
    };
    $[2] = addToast;
    $[3] = mock_body;
    $[4] = nextStep;
    $[5] = source_url;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== curl_command || $[8] !== mock_body || $[9] !== nextStep || $[10] !== request_format || $[11] !== source_url || $[12] !== theme || $[13] !== trigger_option) {
    t5 = () => <Form><Div flex={{
        gap: 4
      }} m={{
        b: 8
      }}><StyledRadioCard as="label" p={3} checked={trigger_option === "url"}><Div flex={{
            align: "center",
            gap: 3
          }}><input checked={trigger_option === "url"} value="url" name="trigger_option" type="radio" onChange={() => setTriggerOption("url")} /><Text semi={true}>Copy and paste source URL</Text></Div><Text size="xs" muted={true} m={{
            t: 1
          }}>Bring Hookdeck source URL to your request producer. Higher effort, more functional.</Text></StyledRadioCard><StyledRadioCard as="label" p={3} checked={trigger_option === "mock"}><Div flex={{
            align: "center",
            gap: 3
          }}><input checked={trigger_option === "mock"} value="mock" name="trigger_option" type="radio" onChange={() => setTriggerOption("mock")} /><Text semi={true}>Test using a mock request</Text></Div><Text size="xs" muted={true} m={{
            t: 1
          }}>Send a dummy request to Hookdeck source URL. Lower effort, best for a quick demo.</Text></StyledRadioCard></Div>{trigger_option === "url" && <Div flex={{
        direction: "column",
        gap: 8
      }}><Div flex={{
          gap: 3
        }}><Div><Badge neutral={true}>1</Badge></Div><Div flex={{
            grow: true,
            direction: "column"
          }}><Text semi={true}>Bring Hookdeck source URL to your request producer</Text><Text muted={true} m={{
              b: 4
            }}>Paste this source URL as an endpoint in the service producing your requests.</Text><CopyableField value={source_url || ""} mono={true} wrap={true} m={{
              b: 6
            }} /><StyledCard overflow_hidden={true}><StyledCardSection muted={true} p={{
                x: 8,
                t: 8
              }} style={{
                lineHeight: 0
              }}><img width={480} src={`/images/paste_url_illustration_${theme.mode}.png`} alt="Copy URL" /></StyledCardSection></StyledCard></Div></Div><Div flex={{
          gap: 3
        }}><Div><Badge neutral={true}>2</Badge></Div><Div flex={{
            grow: true,
            direction: "column"
          }}><Text semi={true}>Trigger event in your request producer</Text><Text muted={true} m={{
              b: 4
            }}>Fire an event that will send HTTP requests to the Hookdeck source URL.</Text><StyledCard overflow_hidden={true}><StyledCardSection muted={true} p={{
                x: 8,
                t: 8
              }} style={{
                lineHeight: 0
              }}><img width={480} src={`/images/trigger_event_illustration_${theme.mode}.png`} alt="Trigger Event" /></StyledCardSection></StyledCard></Div></Div></Div>}{trigger_option === "mock" && <Div><StyledCard overflow_hidden={true}><StyledCardSection><Tabs tabs={[{
              key: "web_ui",
              label: "Web UI",
              help_tooltip: <Text size="s">Send a mock request within this flow.</Text>
            }, {
              key: "curl",
              label: "cURL (via terminal)",
              help_tooltip: <Text size="s">Send a mock request via cURL, using your terminal.</Text>
            }]} active_tab={request_format} onTabSelected={key => setRequestFormat(key as 'web_ui' | 'curl')} border={false} compact={true} m={{
              t: 2,
              x: 3
            }} /></StyledCardSection><StyledCardSection>{request_format === "web_ui" && <Div><Editor language="json" value={mock_body} height="108px" onChange={setMockBody} display="minimal" /></Div>}{request_format === "curl" && <Div><CopyableField value={curl_command} mono={true} variant="command_list" borderless={true} wrap={true} p={3} /></Div>}</StyledCardSection></StyledCard>{request_format === "web_ui" && <Div m={{
          t: 8
        }}><Button data-testid="guided-send-mock-request" primary={true} icon="send" submit={true}>Send mock request</Button></Div>}</Div>}{(trigger_option === "url" || request_format === "curl") && <Div m={{
        t: 8
      }}><Button outline={true} onClick={nextStep}>Next</Button></Div>}</Form>;
    $[7] = curl_command;
    $[8] = mock_body;
    $[9] = nextStep;
    $[10] = request_format;
    $[11] = source_url;
    $[12] = theme;
    $[13] = trigger_option;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <><Formik initialValues={t3} onSubmit={t4}>{t5}</Formik></>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
export default TriggerRequest;